module.exports = __webpack_public_path__ + "static/media/foto2.c14e0ae2.jpg";